import { render } from "./EventParticipation.vue?vue&type=template&id=54f40b9d"
import script from "./EventParticipation.vue?vue&type=script&lang=js"
export * from "./EventParticipation.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__